import axios from "axios";
import { toast } from "react-toastify";
export const GetAccBalanceSumm = (data) => {
  return {
    type: "get_allaccbalance",
    payload: data,
    loader: false,
  };
};
export function getaccBalanceSumm() {
  return (dispatch) => {
    let pgurl = `${
      process.env.REACT_APP_API_URL
    }Reports/DashBoard/BalanceSummary?ProjectId=${localStorage.getItem(
      "ProjectId"
    )}`;
    if (localStorage.getItem("ProjectId") === null) {
      pgurl = `${process.env.REACT_APP_API_URL}Reports/DashBoard/BalanceSummary`;
    }
    axios({
      url: pgurl,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAccBalanceSumm(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
